export class Async {
    constructor(options) {
        if (!(this instanceof Async)) {
            return new Async(options)
        }

        this._element = options.element
        this._initFunction = options.initFunction
        this._transitionBodyClass = options.transitionBodyClass || 'page-transition'
        this._minimalTransitionTime = options.minimalTransitionTime || 1
        this._noAsyncClasses = options.noAsyncClasses || 'no-async'
        this._hasAnalytics = options.hasAnalytics || false
        this._startPageTransition = options.startPageTransition
        this._endPageTransition = options.endPageTransition
        this._href = undefined
    }

    init() {
        if ('fetch' in window) {
            this.initPageLink()

            window.addEventListener('popstate', (e) => {
                if ('scrollRestoration' in history)
                    history.scrollRestoration = 'manual'

                if (typeof(e.state.scrollTop) === 'number')
                    this.loadPage(location.pathname, false, e.state.scrollTop)
            })
        }
    }

    initPageLink () {
        document.addEventListener( 'click', e => {
            const el = e.target.closest('a')
            if (el !== null && el.tagName === 'A') {

                if (el.closest('li') && el.closest('li').classList.contains('no-click')) {
                    e.preventDefault()
                    return
                }

                const classes = this._noAsyncClasses.split(' ')
                if (classes.some(className => el.classList.contains(className)))
                    return

                let alternativePageload = false
                if (classes.some(className => el.classList.contains('about-page-link')))
                    alternativePageload = true

                if (classes.some(className => el.classList.contains('page-numbers'))) {
                    return
                }

                this._href = el.getAttribute('href')
                const download = el.getAttribute('download')
                const target = el.getAttribute('target')
                const conditions = !(this._href.indexOf('mailto:') !== -1) && !(this._href.indexOf('tel:') !== -1) && !(target == '_blank') && download === null

                if (conditions) {
                    e.preventDefault()
                    this.loadPage(this._href, true, 0, alternativePageload)
                }
            }
        })
    }

    loadPage (url, addEntry, scrollPosition, alternativePageload) {
        document.body.classList.add(this._transitionBodyClass)
        if (!alternativePageload)
            this._startPageTransition()

        if (addEntry === true) {
            const doc = document.documentElement
            const top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
            const currentUrl = window.location.href
            const stateData = {
                path: window.location.href,
                scrollTop: top
            }
            window.history.replaceState(stateData, 'title', currentUrl)
        }

        const transitionTimer = new Promise (resolve => {
            setTimeout(() => { resolve({transitionTimer: 'finished'}) }, this._minimalTransitionTime)
        })

        const fetchUrl = new Promise ((resolve, reject) => {
            // The server lets browsers cache pages for a week, so always check for a fresh copy
            fetch(url, { cache: 'no-cache' })
                .then(response => {
                    return response.text()
                })
                .then(html => {
                    resolve({ fetch: 'succes', data: html })
                })
                .catch(err => {
                    reject({ fetch: 'failed', data: err })
                })
        })

        try {
            Promise
                .all([fetchUrl, transitionTimer])
                .then(responses => {
                    if (responses[0].fetch === 'succes') {
                        const html = responses[0].data
                        this.replaceMain(html)
                    } else {
                        console.error('fetch failed: ', responses[0].data)
                    }
                })
                .then(() => {
                    this.afterLoadPage(url, addEntry)
                    window.scrollTo(0, scrollPosition)
                })
                .then(() => {
                    this._initFunction(alternativePageload)
                })
                .then(() => {
                    this._endPageTransition()
                    document.body.classList.remove(this._transitionBodyClass)
                })
                .catch((error) => {
                    console.log('Async error (Force loading page): ', error)
                    window.location = this._href
                })
        } catch (error) {
            console.log('Async error (Force loading page): ', error)
            window.location = this._href
        }
    }

    replaceMain (html) {
        window.scrollTo(0, 0)
        const el = document.querySelector(this._element)

        const re = /<main\b[^>]*>([\s\S]*?)<\/main>/gm
        let match
        while (match = re.exec(html)) {
            el.insertAdjacentHTML('beforebegin', match[0])
            this.findScriptTags(match[0])
        }

        el.remove()
    }

    findScriptTags (string) {
        const re = /<script\b[^>]*>([\s\S]*?)<\/script>/gm
        let match
        while (match = re.exec(string)) {
            this.addScriptToDom(match[1])
        }
    }

    addScriptToDom (code) {
        const s = document.createElement('script')
        s.type = 'text/javascript'
        const el = document.querySelector(this._element)

        try {
            s.appendChild(document.createTextNode(code))
            el.appendChild(s)
        } catch (e) {
            s.text = code
            el.appendChild(s)
        }
    }

    afterLoadPage (url, addEntry) {
        if (addEntry === true) {
            const newUrl = url
            const stateData = {
                path: window.location.href,
                scrollTop: 0
            }
            window.history.pushState(stateData, 'title', newUrl)
        }

        if (typeof(ga) !== 'undefined' && this._hasAnalytics) {
            const path = url.replace(window.location.origin, '')
            ga('gtm2.set', { page: path })
            ga('gtm2.send', 'pageview')
        }

        this.replaceTitlesAndClasses()
    }

    replaceTitlesAndClasses () {
        const el = document.querySelector(this._element)
        const bodyClasses = el.getAttribute('data-body-classes')
        const title = el.getAttribute('data-title')

        document.title = title
        document.body.classList = bodyClasses +' '+ this._transitionBodyClass
        el.removeAttribute('data-body-classes')
        el.removeAttribute('data-title')

        // Set active menu item
        const curMenuItem = document.querySelectorAll('.current-menu-item')
        if (curMenuItem.length !== 0) {
            Array.from(curMenuItem).map(li => {
                li.classList.remove('current-menu-item')
            })
        }

        let currentUrl = window.location.href

        if (window.location.host === 'localhost:8080') // local fix
            currentUrl = currentUrl.substring(6, currentUrl.length)

        var header = document.querySelector('header')
        const newCurrent = header.querySelectorAll('a[href="' + currentUrl + '"]')
        if (newCurrent.length !== 0) {
            Array.from(newCurrent).map(a => {
                a.parentElement.classList.add('current-menu-item')
            })
        }
    }
}

// module.exports = Async
